export default __webpack_public_path__ + "static/media/helpImg-1.ba117c3d.png";